<template>
    <div>
        <van-nav-bar
                title="添加代理商"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />


            <van-field
                    v-model="form.username"
                    name="姓名"
                    label="姓名"
                    required
                    placeholder="姓名"
                    message="请填写姓名"
            />
            <van-field
                    v-model="form.mobile"
                    type="tel"
                    name="手机"
                    label="手机"
                    placeholder="手机"
                    required
                    message="请填写手机号码"
            />
            <van-field
                    v-model="form.password"
                    type="password"
                    name="密码"
                    label="密码"
                    required
                    message="请填写密码"
                    placeholder="密码"
            />
        <van-cell is-link title="类型" :value="agentType[agentTypeID]" @click="show = true" />
        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
            <div style="margin: 16px;">
                <van-button round block type="info" @click="onSubmit">
                    提交
                </van-button>
            </div>

    </div>
</template>

<script>
    export default {
        name: "agentadd",
        data() {
            return {
                show:false,
                agentTypeID:1,
                agentType:{
                    0:'公众号',
                    1:'百分比',
                    2:'套餐成本',
                    3:'积分充值',
                },
                actions: [{ name: '分佣方式',disabled:true }, { name: '百分比' }, { name: '套餐成本' },{ name: '积分充值' }],
                form:{

                }
            };
        },
        methods: {
            onClickLeft(){
                window.history.go(-1)
            },
            onSelect(item,index){
              this.show = false;
              this.agentTypeID =index
            },
            onSubmit(){
                if(!this.form.username || !this.form.mobile || !this.form.password){
                    this.$toast.fail('请完善资料再提交');
                    return false;
                }
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                });
                this.fetchDataPost('/agent/add',this.form,(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success({message:res.msg,onClose(){
                            window.history.go(-1)
                            }})
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            }
        },
        created: function () {

        }
    };
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/agentadd.vue